import React from 'react'
import PropTypes from 'prop-types'
import { getIn } from 'formik'
import Dropdown from '~/components/common/Dropdown'

const FormDropdown = ({
  onChange,
  form,
  field,
  clearable,
  disabled,
  ...props
}) => (
  <Dropdown
    value={getIn(form.values, field.name)}
    inputProps={{
      error: getIn(form.touched, field.name) && getIn(form.errors, field.name),
      helperText:
        getIn(form.touched, field.name) && getIn(form.errors, field.name),
    }}
    {...props}
    onChange={(_, newValue) => {
      onChange(newValue)
      form.setFieldValue(field.name, newValue.value)
    }}
    disabled={disabled || !!form.values.__readOnly}
  />
)

FormDropdown.defaultProps = {
  onChange: () => {},
  label: '',
  clearable: false,
  disabled: false,
}

FormDropdown.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  clearable: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default FormDropdown
